import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Form, Modal, Button } from 'react-bootstrap';
import { FaPlus, FaCheck, FaEdit, FaTrash, FaSortAmountUp, FaChartLine, FaSortAmountDown, FaBell, FaArrowRight, FaArrowLeft, FaPaperPlane, FaUserCheck, FaChalkboardTeacher } from 'react-icons/fa';
import Navbar from '../dashboard/navbar';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css'; // Importez le style bubble
import axios from 'axios';
import { getAuthToken } from '../../authToken';


const Liste_etude = ({ titre }) => {
    useAuth();
    const [etude, setEtude] = useState([]);
    const [selectedEtude, setSelectedEtude] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [nouvEtude, setNouvEtude] = useState({
        titre: '',
        statut: '',
        tag: '',
    });
    const [modifEtude, setModifEtude] = useState({
        titre: '',
        statut: '',
        tag: '',
    });
    const [tags, setTags] = useState([]); // Pour stocker les tag
    const [isLoading, setIsLoading] = useState(false); // Pour gérer le loader

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const totalItems = etude.length;  // Si 'formationList' contient toutes les formations


    const location = useLocation();

    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Études de cas";
        }
    }, [user_id]);


    const fetchEtude = async () => {
        setIsLoading(true);
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-etude/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            // const response = await fetch(process.env.REACT_APP_HOTE + '/liste-etude/');
            if (response.ok) {
                setIsLoading(false);
                const data = await response.json();
                setEtude(data);
            } else {
                setIsLoading(false);
                const data = await response.json();
                console.error('Erreur lors de la récupération des études', data);
            }
        } catch (error) {
            setIsLoading(false);
            console.error('Erreur réseau:', error);
        }
    };
    useEffect(() => {
        fetchEtude();
    }, []);


    useEffect(() => {
        const fetchTags = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + '/liste-tag/');
                if (response.ok) {
                    const data = await response.json();
                    setTags(data);
                } else {
                    console.error('Erreur lors de la récupération des tags');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        };

        fetchTags();
    }, []);


    // Handle alerts
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
            // fetchEtude()
        }, 3000);
    };

    const handleRowClick = (etude) => {
        setSelectedEtude(etude);
    };


    // Filter formations by search term
    const filteredEtude = etude.filter(etude =>
        etude.titre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        etude.statut.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Sort Études
    const sortedEtude = [...filteredEtude].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Pagination logic
    const indexOfLastEtudeDeCas = currentPage * itemsPerPage;
    const indexOfFirstEtudeDeCas = indexOfLastEtudeDeCas - itemsPerPage;
    const currentEtude = sortedEtude.slice(indexOfFirstEtudeDeCas, indexOfLastEtudeDeCas);
    const totalPages = Math.ceil(sortedEtude.length / itemsPerPage);

    // Handle items per page change
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    // Handle modifier action


    // Handle show delete modal
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    const handleShowEditModal = () => setShowEditModal(true);
    const handleCloseEditModal = () => setShowEditModal(false);

    const handleShowAddModal = () => setShowAddModal(true);
    const handleCloseAddModal = () => setShowAddModal(false);


    const handleEnregEtude = async () => {
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(process.env.REACT_APP_HOTE + `/ajouter-etude/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(nouvEtude),
            });

            if (response.ok) {
                const result = await response.json();
                console.log('Etude ajouté avec succès:', result);
                handleCloseAddModal(); // Ferme le modal après l'ajout
                fetchEtude();
                showAlert("Etude ajouté avec succès !");
            } else {
                const errorData = await response.json();
                console.error('Erreur du serveur:', errorData);
                showAlert('Erreur lors de l’ajout du Etude : ' + (errorData.message || 'Erreur inconnue.'));
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur de connexion au serveur. Veuillez réessayer plus tard.');
        }
    };

    useEffect(() => {
        const fetchEtudeModif = async () => {
            if (!selectedEtude) {
                console.error('Aucune étude sélectionnée');
                return; // Si aucune étude n'est sélectionnée, ne pas continuer
            }

            try {
                const token = localStorage.getItem('access_token');

                const response = await fetch(`${process.env.REACT_APP_HOTE}/etude-info/${selectedEtude.id}/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                // const response = await fetch(`${process.env.REACT_APP_HOTE}/etude-info/${selectedEtude.id}/`);
                if (!response.ok) {
                    throw new Error('Erreur lors de la récupération de l\'étude.');
                }
                const data = await response.json();

                // Mettre à jour l'état avec les données récupérées
                setModifEtude(data);
                console.log('Données récupérées :', data.etude);
            } catch (error) {
                console.error('Erreur lors de la récupération des données de l\'étude :', error);
                // showAlert('Impossible de charger les données de l\'étude.');
            } finally {
                setIsLoading(false); // Désactive le spinner
            }
        };

        if (selectedEtude) { // Vérifie si une étude est sélectionnée avant de faire la requête
            fetchEtudeModif();
        }
    }, [selectedEtude]); // Dépendance sur selectedEtude


    const handleModifierEtude = async (event) => {
        event.preventDefault();
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-etude/${selectedEtude.id}/${user_id}/`, {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(modifEtude),
            });
            if (response.ok) {
                handleCloseEditModal();
                fetchEtude();
                showAlert("Etude modifiée avec succès !");
            } else {
                alert("Erreur lors de la modification de la etude.");
            }
        } catch (error) {
            console.error("Erreur réseau :", error);
        }
    };


    const handleDeleteEtude = async () => {
        if (selectedEtude) {
            try {
                const token = localStorage.getItem('access_token');

                const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-etude/${selectedEtude.id}/${user_id}/`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });

                if (response.ok) {
                    setShowDeleteModal(false); // Fermez le modal avant de modifier l'état
                    fetchEtude();
                    showAlert("Étude supprimée avec succès !");
                } else {
                    console.error('Erreur lors de la suppression de l\'étude');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        }
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("AdminEtudeDeCas")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaChalkboardTeacher size={25} className='mr-2' />Gestion des études de cas</h2>
                            <small>Administration des études de cas.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-etude`}> Études de cas</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Liste des études de cas</h5>
                                <div>
                                    <Link onClick={handleShowAddModal} className="btn btn-success ms-2 mr-2 mt-1">
                                        <FaPlus /> Ajouter
                                    </Link>
                                    <button
                                        onClick={() => handleShowEditModal(selectedEtude)}
                                        className={`btn ms-2 mr-2 mt-1 ${selectedEtude ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedEtude} // Désactiver le bouton si aucune formation n'est sélectionnée
                                    >
                                        <FaEdit /> Modifier
                                    </button>
                                    <button
                                        onClick={handleShowDeleteModal}
                                        className={`btn ms-2 mr-2 mt-1 ${selectedEtude ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedEtude}
                                    >
                                        <FaTrash /> Supprimer
                                    </button>
                                </div>
                            </div>

                            {alert.message && (
                                <div className={`alert alert-${alert.type}`}>
                                    {alert.message}
                                </div>
                            )}

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">

                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control"
                                                    style={{ maxWidth: '150px', width: '100%' }} // Largeur fixe ou maximale selon besoin
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <div className="table-responsive" style={{ fontSize: '11px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ minWidth: '150px' }} onClick={() => handleSort('titre')}>
                                                                Titre {sortConfig.key === 'titre'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ minWidth: '100px' }} onClick={() => handleSort('statut')}>
                                                                Statut {sortConfig.key === 'statut'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ minWidth: '100px' }} onClick={() => handleSort('tag')}>
                                                                Tag {sortConfig.key === 'tag'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    {!isLoading ? (
                                                        <tbody>
                                                            {currentEtude.length > 0 ? currentEtude.map((etude) => (
                                                                <tr
                                                                    key={etude.id}
                                                                    className={`bg-white ${selectedEtude && selectedEtude.id === etude.id ? 'bg-success text-white' : ''}`}
                                                                    onClick={() => handleRowClick(etude)}
                                                                >
                                                                    <td>
                                                                        {etude.titre}
                                                                        <div className='lesInfos'>
                                                                            {/* <small>Titre : <small dangerouslySetInnerHTML={{ __html: etude.titre }}></small></small><br/> */}
                                                                            <small>Statut : {etude.statut}</small><br />
                                                                            <small>Tag : {etude.tag}</small><br />
                                                                        </div>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">{etude.statut}</td>
                                                                    <td className="d-none d-md-table-cell">{etude.tag}</td>
                                                                </tr>
                                                            )) : (
                                                                <tr>
                                                                    <td colSpan="4" className="text-center">Aucune étude de cas disponible</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    ) : (
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan="8" className="text-center p-5">
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <div className="spiner-example">
                                                                            <div className="sk-spinner sk-spinner-wave">
                                                                                <div className="sk-rect1 mr-1"></div>
                                                                                <div className="sk-rect2 mr-1"></div>
                                                                                <div className="sk-rect3 mr-1"></div>
                                                                                <div className="sk-rect4 mr-1"></div>
                                                                                <div className="sk-rect5"></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    )}

                                                </table>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstEtudeDeCas + 1} à ${Math.min(indexOfLastEtudeDeCas, totalItems)} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5; // Nombre total de pages à afficher
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        // Ajuster le startPage si la fin dépasse le total des pages
                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        // Ajout des boutons de pages
                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    {/* Bouton pour aller à la dernière page */}
                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Modal show={showAddModal} onHide={handleCloseAddModal}>
                        <Modal.Header>
                            <Modal.Title>Ajouter étude de cas</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Titre</Form.Label>
                                    <Form.Control
                                        type="text"
                                        required
                                        value={nouvEtude.titre}
                                        onChange={(event) => {
                                            setNouvEtude({
                                                ...nouvEtude,
                                                titre: event.target.value,
                                            });
                                        }}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Statut</Form.Label>
                                    <Form.Control
                                        as="select"
                                        required
                                        value={nouvEtude.statut}
                                        onChange={(event) => {
                                            setNouvEtude({
                                                ...nouvEtude,
                                                statut: event.target.value,
                                            });
                                        }}
                                    >
                                        <option value="">Sélectionnez un statut</option>
                                        <option value="Brouillon">Brouillon</option>
                                        <option value="Publié">Publié</option>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Tag</Form.Label>
                                    <select
                                        className="form-control"
                                        required
                                        value={nouvEtude.tag || ""}

                                        onChange={(event) => {
                                            setNouvEtude({
                                                ...nouvEtude,
                                                tag: event.target.value,
                                            });
                                        }}
                                    >
                                        <option value="">Choisissez un tag</option>
                                        {tags
                                            .filter(tag => !/^J[1-9]$|^J[1-2][0-9]$|^J30$/.test(tag.titre))
                                            .map(tag => (
                                                <option key={tag.id} value={tag.titre}>
                                                    {tag.titre}
                                                </option>
                                            ))}
                                    </select>
                                </Form.Group>

                                {/* Section des boutons */}
                                <div className="d-flex justify-content-end mt-4">
                                    <Button
                                        variant="secondary"
                                        className="me-2 mr-2"
                                        onClick={handleCloseAddModal}
                                    >
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="success"
                                        className="me-2 mr-2"
                                        onClick={() => handleEnregEtude()}
                                    >
                                        Enregistrer
                                    </Button>
                                </div>
                            </Form>
                        </Modal.Body>
                    </Modal>

                    <Modal show={showEditModal} onHide={handleCloseEditModal}>
                        <Modal.Header>
                            <Modal.Title>Modifier l'étude de cas</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form onSubmit={handleModifierEtude}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Titre</Form.Label>
                                    <Form.Control
                                        type="text"
                                        required
                                        value={modifEtude.titre}
                                        onChange={(event) => {
                                            setModifEtude({
                                                ...modifEtude,
                                                titre: event.target.value, // Utilisez event.target.value pour obtenir la valeur
                                            });
                                        }}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Statut</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="statut"
                                        value={modifEtude.statut}
                                        onChange={(e) =>
                                            setModifEtude({
                                                ...modifEtude,
                                                statut: e.target.value,
                                            })
                                        }
                                        required
                                    >
                                        <option value="">Sélectionnez un statut</option>
                                        <option value="Brouillon">Brouillon</option>
                                        <option value="Publié">Publié</option>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Tag</Form.Label>
                                    <select
                                        className="form-control"
                                        required
                                        value={modifEtude.tag}
                                        onChange={(e) =>
                                            setModifEtude({
                                                ...modifEtude,
                                                tag: e.target.value,
                                            })
                                        }
                                    >
                                        <option value="">Choisissez un module</option>
                                        {tags
                                            .filter(tag => !/^J[1-9]$|^J[1-2][0-9]$|^J30$/.test(tag.titre))
                                            .map(tag => (
                                                <option key={tag.id} value={tag.titre}>
                                                    {tag.titre}
                                                </option>
                                            ))}
                                    </select>
                                </Form.Group>

                                {/* Boutons */}
                                <div className="d-flex justify-content-end mt-4">
                                    <Button
                                        variant="secondary"
                                        className="me-2 mr-2"
                                        onClick={handleCloseEditModal}
                                    >
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="success"
                                        type="submit"
                                    >
                                        {isLoading ? (
                                            <span
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                        ) : (
                                            <>
                                                Enregistrer
                                            </>
                                        )}
                                    </Button>
                                </div>
                            </Form>
                        </Modal.Body>
                    </Modal>

                    <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                        <Modal.Header>
                            <Modal.Title>Confirmer la suppression</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Êtes-vous sûr de vouloir supprimer l'étude : {selectedEtude && selectedEtude.titre} ?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseDeleteModal}>
                                Annuler
                            </Button>
                            <Button variant="success" onClick={handleDeleteEtude}>
                                Supprimer
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        </div>
    );
};

export default Liste_etude;
